export let timingListProps = {
    key: 0,
    id: 0,
    day_number: 0,
    working_day: true,
    store_opens_at_hour: null,
    store_opens_at_minute: null,
    store_opens_at_am_pm: null,
    store_closes_at_hour: null,
    store_closes_at_minute: null,
    store_closes_at_am_pm: null
}

export let eStoreTopProps = {
    key: 0,
    menu_id: 0,
    menu_name: '',
    source_id: 0,
    source_name: '',
    hidden: false
}

export let eStoreSocialMediaProps = [
    {site_name: 'Facebook', link: '', icon: 'fa-brands fa-facebook-f', blank_target: true, display: false},
    {site_name: 'Twitter', link: '', icon: 'fa-brands fa-twitter', blank_target: true, display: false},
    {site_name: 'Instagram', link: '', icon: 'fa-brands fa-instagram', blank_target: true, display: false},
]

export let eStoreAboutUsProps = {
    heading: '',
    sub_heading: '',
    content: '<section class="mt-3 py-5 bg-light">\n'
    +'<div class="container align-center">\n\n'
        
        
    +'<div class="row">\n'
    +'<div class="col-sm-12">\n'	
    +'<p class="heading-2 lh-1">ABOUT TITLE</p>	\n'
        
    +'<p class="heading-3-thin mt-2">SUB_TITLE</p>\n\n\n'
        
        
        
    +'</div>\n'
    
    +'</div>\n'
    +'</div>\n'
    +'</section>\n\n'
          
          
          
    +'<section class=" py-5">\n'
    +'<div class="container align-center">\n'
    
    +'<span class="content-text">ABOUT CONTENT</span>\n\n'
    
    
        
    
        
    +'</div>\n'
    +'</section>'
}

export let eStoreShipmentMethodProp = {
    key: 0,
    label: '',
    currency_id: 0,
    cost: 0,
    display_to_self_country: true
}

export const eStoreBannersProp = {
    key: 0,
    button_label: '',
    button_target: '',
    image: ''
}

export let eStoreImprintProp = {
    key: 0,
    image_path: '',
    link: '',
    description: ''
}

export let eStoreZohoProp = {
    key: 0,
    id: 0,
    store_label: '',
    tax_intent: {value: '', list: ['TAXABLE','NON_TAXABLE','EXPORT','EXEMPT']},
    zoho_org_id: '',
    zoho_org_name: '',
    zoho_branch_id: '',
    zoho_branch_name: '',
    zoho_warehouse_id: '',
    zoho_warehouse_name: '',
    is_active: true,
    zoho_bank_id: '',
    zoho_bank_name: '',
    zoho_payment_id: '',
    zoho_payment_name: '',
    eta_order_prefix: ''
}

export let dataProps = {
    id: 0,
    legal_name: '', 
    brand_name: '',  
    locality_name: '',
    address: '', 
    city_id: null, 
    province_id: null, 
    country_id: null, 
    postal_code: '',
    contact_number: '', 
    email_address: '', 
    website: '', 
    retail: true, 
    warehouse: true, 
    warehouse_id: 0,
    factory: true, 
    brand_logo: '', 
    sales_invoice_footer_notes: '', 
    default_print_measurement_with_work_order: true,
    default_print_styling_with_work_order: true, 
    default_print_style_choice_image_with_work_order: false, 
    default_print_customer_profile_with_work_order: true, 
    default_print_sample_image_with_work_order: true, 
    sale_print_header_footer: true, 
    sale_print_header_margin: 3,
    default_sale_print_paper_size: 0, 
    work_order_print_horizontal: true, 
    work_order_print_qc_note: true, 
    default_print_customer_name_on_work_order: true, 
    auto_generate_order_number: true, 
    order_number_prefix: 'OR-1000', 
    order_number_start_number: 1, 
    auto_generate_invoice_number: true, 
    invoice_number_prefix: 'INV-1000', 
    invoice_number_start_number: 1, 
    charge_sale_tax: false, 
    tax_list_id: null, 
    tax_registration_number: '', 
    sales_estimate_footer_notes: '',
    sales_order_footer_notes: '',
    sale_order_print_label: 'SALE ORDER',
    po_footer_notes: '',
    external_sourcing_footer_notes: '',
    factory_id: 0,
    biometric_machine_id: '',
    biometric_auth_token: '',
    whats_app_api_key: '',
    e_store: false,
    default_sales_currency: null,
    shop_timing_list: [JSON.parse(JSON.stringify(timingListProps))],
    deleted_timing_items: [],

    e_store_logo: '',
    e_store_about_us: JSON.parse(JSON.stringify(eStoreAboutUsProps)),
    e_store_domain_name: '',
    e_store_menu_top_list: [JSON.parse(JSON.stringify(eStoreTopProps))],
    e_store_menu_bottom_list: [JSON.parse(JSON.stringify(eStoreTopProps))],
    e_store_footer_copright_information: '',
    e_store_social_media_link_list: JSON.parse(JSON.stringify(eStoreSocialMediaProps)),
    e_store_newsletter_subscription_heading: '',
    e_store_privacy_policy: '',
    e_store_cancellation_policy: '',
    e_store_job_opening: '',
    e_store_dedicated_subscription_page: '',
    
    e_store_b2b: false,
    e_payment_mode_id: null,
    
    e_store_shipment_method_list: [JSON.parse(JSON.stringify(eStoreShipmentMethodProp))],
    e_store_banners: JSON.parse(JSON.stringify(eStoreBannersProp)),

    e_store_imprint: [JSON.parse(JSON.stringify(eStoreImprintProp))],
    sms_sender_id: '',
    e_com_access_token: '',

    zoho_store_routing: [JSON.parse(JSON.stringify(eStoreZohoProp))],
    deleted_zoho_store_routing: []
}

/*CREATE TABLE tenant_zoho_store_routes (
  id int NOT NULL AUTO_INCREMENT,
  eta_store_id int NOT NULL,
  tax_intent enum('TAXABLE','NON_TAXABLE','EXPORT','EXEMPT') NOT NULL,
  zoho_org_id varchar(50) NOT NULL,
  zoho_org_name varchar(100) DEFAULT NULL,
  zoho_branch_id varchar(50) DEFAULT NULL,
  zoho_branch_name varchar(100) DEFAULT NULL,
  zoho_warehouse_id varchar(50) DEFAULT NULL,
  zoho_warehouse_name varchar(100) DEFAULT NULL,
  is_active tinyint(1) DEFAULT '1',
  zoho_bank_id text,
  zoho_bank_name text,
  zoho_payment_id text,
  zoho_payment_name text,
  eta_order_prefix text COMMENT 'this decides which eta order goes to which zoho store',
  PRIMARY KEY (id),
  UNIQUE KEY uniq_route (eta_store_id,tax_intent)
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_0900_ai_ci;
*/


// WEBPACK FOOTER //
// ./src/store/modules/shop/properties.js